import { showModal } from 'modal.react.js';

import area from 'components/shared/GlobalModalArea/area';

import { IContentPage } from '../../TripEventModalContents/shared/types';
import { ContentCreationModal } from './ContentCreationModal';
import * as types from './types';

export const openContentCreationModal = async ({ type, initialValues, withoutOneOff }: types.OpenModalFuncProps) => {
  return await showModal<IContentPage | false>(
    area,
    <ContentCreationModal type={type} initialValues={initialValues} withoutOneOff={withoutOneOff} />,
  );
};
